<ng-template #confirmDialog let-c="close" let-d="dismiss">
  <div class="modal-header" *ngIf="showHeader">
    <div class="float-right" *ngIf="showHeader">
      <button type="button" class="btn btn-link text-dark" (click)="c('cancelled')"><i class="fas fa-times"></i></button>
    </div>
    <div [innerHTML]="headerContent | safeHtml"></div>
  </div>
  <div class="modal-body" *ngIf="showBody">
    <div class="float-right" *ngIf="!showHeader">
      <button type="button" class="btn btn-link text-dark" (click)="c('cancelled')"><i class="fas fa-times"></i></button>
    </div>
    <div [innerHTML]="bodyContent | safeHtml"></div>
  </div>
  <div class="modal-footer text-right">
    <button type="button" [class]="cancelButtonClasses" (click)="c('cancelled')">{{ cancelButtonText }}</button>
    &nbsp;
    <button type="button" [class]="confirmButtonClasses" (click)="c('confirmed')">{{ confirmButtonText }}</button>
  </div>
</ng-template>
